import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        primary: '#154786',
        secondary: '#F7CB95',
        accent: '#d0dae7',
        error: '#E15E49',
        info: '#10366F',
        success: '#1CAD99',
        warning: '#FFC107',
        tertiary: '#ededed',
      },
    },
  },
});
